<template>
  <div class="doc-page d-flex mx-auto flex-row">
    <loading-dialog :show="loading" />
  </div>
</template>
<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import Api from "@/main/api";

export default {
  name: "Payment",
  components: {
    LoadingDialog
  },

  data: () => ({
    loading: false,
  }),


  mounted() {
    this.loading = true
    const urlParams = new URLSearchParams(window.location.search);
    const data = urlParams.get('invoice');
    console.log(data)
    if(data){
      Api.faker.processPayment(data)
      .then(() => {
        window.history.back()
        // console.log("Stopped")
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => this.loading = false)
    } else{
     window.location.href = '/not_found'
    }
  }
}
</script>


<style lang="scss" scoped>

</style>
